import type { ArchiMateElement, ArchiMateRelationship } from './types';

export interface SimulationResult {
  cost: number;
  performance: number;
  reliability: number;
}

// Default values for simulation if not provided in element metadata
const DEFAULT_METRICS = {
  cost: 100, // Monthly cost
  performance: 0.99, // Latency factor (lower is better)
  reliability: 0.999, // Uptime percentage
};

export function runSimulation(
  elements: ArchiMateElement[],
  relationships: ArchiMateRelationship[]
): SimulationResult {
  let totalCost = 0;
  let overallPerformance = 1;
  let overallReliability = 1;

  elements.forEach((element) => {
    const properties = element.properties || {};
    const cost = properties.cost ? parseFloat(properties.cost) : DEFAULT_METRICS.cost;
    const performance = properties.performance ? parseFloat(properties.performance) : DEFAULT_METRICS.performance;
    const reliability = properties.reliability ? parseFloat(properties.reliability) : DEFAULT_METRICS.reliability;

    totalCost += cost;
    overallPerformance *= performance; // Simplified: assume sequential processing
    overallReliability *= reliability; // Simplified: assume components in series
  });

  // Adjust for complexity (number of relationships)
  const complexityFactor = 1 + relationships.length * 0.05;
  overallPerformance /= complexityFactor;
  overallReliability /= complexityFactor;

  return {
    cost: parseFloat(totalCost.toFixed(2)),
    performance: parseFloat(Math.max(0, Math.min(1, overallPerformance)).toFixed(4)),
    reliability: parseFloat(Math.max(0, Math.min(1, overallReliability)).toFixed(5)),
  };
}
